import React, { useContext, useEffect, useState } from "react";
import StoreMenu from "../../StoreMenu";
import { useNavigate } from "react-router-dom";
import { getUserData } from "../../../utils/localStorage";
import {
  getBrandStore,
  getBrandUsers,
} from "../../../services/StoreUsers/PostStoreUsers";
import { formatDate } from "../../../constants/DateUtil/DateUtil";
import { ProgressSpinner } from "primereact/progressspinner";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { getBrandWarehouse } from "../../../services/warehouse/Warehouse";
import AdminMenu from "../../AdminMenu";

const WarehouseManagementList = () => {
  const navigate = useNavigate();
  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [warehouseInfoData, setWarehouseInfoData] = useState([]);
  const handleConfirmAndContinue = () => {
    setModalMenuVisible(true);
  };
  const [storeInfoData, setStoreInfoData] = useState([]);

  const [visible, setVisible] = useState(false);

  const { brandProfileData } = getUserData();
  let brandId = brandProfileData.id;
  let enabledGarmentProcessStageBrand =
    brandProfileData.enabledGarmentProcessStage;
  const [loading, setLoading] = useState(false);

  const fetchWarehouseUser = () => {
    setLoading(true);
    getBrandWarehouse(brandId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setWarehouseInfoData(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };
  useEffect(() => {
    fetchWarehouseUser();
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  const filterUserList = () => {
    return warehouseInfoData.filter((item) => {
      const fullName = item.name?.toLowerCase();
      const matchesSearchTerm = fullName?.includes(searchTerm.toLowerCase());
      return matchesSearchTerm;
    });
  };
  const filteredUserData = filterUserList();

  const renderCardItem = (data) => {
    return data?.map((item, index) => {
      return (
        <div>
          <div className="flex-1 ">
            <div className="m-4 shadow-4">
              <div className="flex flex-1">
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Name :
                  </p>
                  <p className="text-lg font-medium capitalize">{item.name}</p>
                </div>
                <div
                  className="flex-1 px-3 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Mobile Number :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.mobileNo}
                  </p>
                </div>
                <div
                  className="flex-1 px-3 py-1 flex justify-content-between"
                  style={{
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <div>
                    <p
                      className="text-md font-normal capitalize"
                      style={{ color: "#75879B" }}
                    >
                      Email Id :
                    </p>
                    <p className="text-lg font-medium capitalize">
                      {item.email}
                    </p>
                  </div>
                  <div
                    className="mr-4 mt-2"
                    onClick={() =>
                      navigate("/WarehouseManagementCreate", {
                        state: {
                          id: item.id,
                        },
                      })
                    }
                  >
                    <i
                      className="pi pi-pencil"
                      style={{
                        fontSize: "25px",
                        cursor: "pointer",
                        color: "#2B70D7",
                      }}
                    ></i>
                  </div>
                  <div
                    className="mr-4 mt-2 cursor-pointer"
                    onClick={() =>
                      navigate("/WarehouseConfigList", {
                        state: {
                          id: item.id,
                          enabledGarmentProcessStage:
                            item.enabledGarmentProcessStage,
                          enabledGarmentProcessStageBrand:
                            enabledGarmentProcessStageBrand,
                        },
                      })
                    }
                  >
                    <img
                      src="Laundy_App_Icons_Gifs/Customer_Info_GIFs/Book_New_Order.gif"
                      alt="config"
                      style={{
                        width: 50,
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="flex flex-1">
                <div
                  className="flex-1 px-2 py-1"
                  style={{
                    backgroundColor: "#E2F4F8",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Status:
                  </p>

                  {item.status === true ? (
                    <div className="flex">
                      <p className="text-lg font-medium capitalize">Active </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                        }
                      />
                    </div>
                  ) : (
                    <div>
                      <p className="text-lg font-medium capitalize">
                        DeActive{" "}
                      </p>
                      <img
                        src={
                          "Laundy_App_Icons_Gifs/Order_Statuses_icons/Unpaid_Payment_Status.png"
                        }
                      />
                    </div>
                  )}
                </div>
                <div
                  className=" px-3 py-1"
                  style={{
                    flex: 2,
                    backgroundColor: "#F8FFEE",
                  }}
                >
                  <p
                    className="text-md font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Address :
                  </p>
                  <p className="text-lg font-medium capitalize">
                    {item.address.fullAddress}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    });
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/Setting")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-2xl text-white font-bold uppercase">
                Warehouse Management
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#fff" }}
            ></i>
          </div>
        </div>
      </div>

      <div className="my-2 mx-5 flex flex-1">
        <div
          onClick={() =>
            navigate("/WarehouseManagementCreate", {
              state: {
                id: null,
              },
            })
          }
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
        >
          <div>
            <img
              src={
                "Laundy_App_Icons_Gifs/Home_Page_Menu_Bar/Quick_add_customer.png"
              }
              style={{ width: 27 }}
            />
          </div>
        </div>
        <div className="flex-1">
          <IconField iconPosition="left" className="flex flex-1">
            <InputIcon className="pi pi-search text-xl"> </InputIcon>
            <InputText
              placeholder={"Search Warehouse"}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="text-xl flex flex-1 py-1 px-5"
              style={{ borderRadius: 30 }}
            />
          </IconField>
        </div>

        <div
          className="flex justify-content-center align-items-center mx-2 cursor-pointer"
          onClick={() => setSearchTerm("")}
        >
          <div>
            <p className="text-4xl font-bold " style={{ color: "red" }}>
              X
            </p>
          </div>
        </div>
      </div>
      <div>
        {loading ? (
          <div style={{ flex: 1 }}>
            <div className="text-center">
              <ProgressSpinner
                style={{ width: "70px", height: "70px" }}
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration="2s"
              />
            </div>
          </div>
        ) : warehouseInfoData?.length > 0 ? (
          <div>
            <div>{renderCardItem(filteredUserData || warehouseInfoData)}</div>
          </div>
        ) : (
          <div className="flex justify-content-center align-items-center">
            <p className="text-xl font-medium">No Order Found</p>
          </div>
        )}
      </div>

      <AdminMenu setVisible={setVisible} visible={visible} />
    </div>
  );
};

export default WarehouseManagementList;
